module.exports = __webpack_public_path__ + "static/media/modalReporteActual.bf9c6ef7.png";